(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carrusel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

    const iniciar = (raiz) => {
      if (raiz.dataset.heroListo) return;
      raiz.dataset.heroListo = 'true';

      const slides = Array.from(raiz.querySelectorAll('[data-hero-slide]'));
      const actual = raiz.querySelector('[data-hero-actual]');
      const puntos = Array.from(raiz.querySelectorAll('[data-hero-punto]'));
      const pista = raiz.querySelector('[data-hero-pista]');
      if (slides.length < 2) return;

      let indice = 0;
      const mostrar = (nuevo) => {
        indice = (nuevo + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const activo = i === indice;
          slide.classList.toggle('is-activo', activo);
          slide.toggleAttribute('inert', !activo);
          if (activo) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        puntos.forEach((p, i) => p.setAttribute('aria-current', String(i === indice)));
        if (actual) actual.textContent = String(indice + 1);
      };

      // --- Avance automático (opcional): se pausa por varios motivos a la vez ---
      const segundos = Number(raiz.dataset.heroAutoplay || 0);
      const pausas = new Set();
      let reloj = null;
      const detener = () => {
        clearInterval(reloj);
        reloj = null;
      };
      const arrancar = () => {
        detener();
        if (!segundos || sinMovimiento.matches || pausas.size) return;
        reloj = setInterval(() => mostrar(indice + 1), segundos * 1000);
      };
      const pausar = (motivo) => {
        pausas.add(motivo);
        detener();
      };
      const seguir = (motivo) => {
        pausas.delete(motivo);
        arrancar();
      };
      // Una acción del usuario reinicia la cuenta, para no saltar justo después.
      const ir = (nuevo) => {
        mostrar(nuevo);
        arrancar();
      };

      raiz.querySelector('[data-hero-anterior]')?.addEventListener('click', () => ir(indice - 1));
      raiz.querySelector('[data-hero-siguiente]')?.addEventListener('click', () => ir(indice + 1));
      puntos.forEach((p) => p.addEventListener('click', () => ir(Number(p.dataset.heroPunto))));

      if (segundos) {
        raiz.addEventListener('mouseenter', () => pausar('mouse'));
        raiz.addEventListener('mouseleave', () => seguir('mouse'));
        raiz.addEventListener('focusin', () => pausar('foco'));
        raiz.addEventListener('focusout', (e) => {
          if (!raiz.contains(e.relatedTarget)) seguir('foco');
        });
        document.addEventListener('visibilitychange', () => (document.hidden ? pausar('oculta') : seguir('oculta')));
        if (sinMovimiento.addEventListener) sinMovimiento.addEventListener('change', arrancar);
        arrancar();
      }

      // --- Deslizar con el dedo ---
      if (pista) {
        let x0 = null;
        let y0 = null;
        pista.addEventListener('touchstart', (e) => {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
          pausar('toque');
        }, { passive: true });
        pista.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          pausas.delete('toque');
          // Gesto horizontal claro: más de 40px y más horizontal que vertical
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            pista.dataset.heroDeslizo = 'true'; // que el gesto no abra el enlace
            ir(dx < 0 ? indice + 1 : indice - 1);
          } else {
            arrancar();
          }
        }, { passive: true });
        pista.addEventListener('touchcancel', () => {
          x0 = null;
          seguir('toque');
        });
        pista.addEventListener('click', (e) => {
          if (pista.dataset.heroDeslizo) {
            e.preventDefault();
            delete pista.dataset.heroDeslizo;
          }
        }, true);
      }

      // En el editor: al elegir un bloque se muestra su slide y se pausa.
      document.addEventListener('shopify:block:select', (e) => {
        const i = slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i !== -1) {
          pausar('editor');
          mostrar(i);
        }
      });
      document.addEventListener('shopify:block:deselect', () => seguir('editor'));
    };

    const todos = () => document.querySelectorAll('.hero-carrusel').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
    else todos();
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();
})();
